import * as React from 'react';
import { Table } from 'react-bootstrap';
import SwaggerUI from 'swagger-ui';
import '../../node_modules/swagger-ui/dist/swagger-ui.css';
import './Documentation.css';

export const DocumentationPage = (props: any) => {
    const [sideNavCreated, setSideNavCreated] = React.useState(false);
    React.useEffect(() => {
        SwaggerUI({
            domNode: document.getElementById("api-docs"),
            supportedSubmitMethods: [],
            // url: document.location.origin + "/api/swagger/v1/swagger.json",
            url: "https://api.bilflo.com/swagger/v1/swagger.json",
            // docExpansion: "full",
        });
    }, []);

    // Loop until Swagger UI has loaded then create side nav
    const checkExist = setInterval(function () {
        if (document.querySelector("[data-tag]") !== null) {
            clearInterval(checkExist);

            // Add this method with your code
            if (!sideNavCreated) {
                createSideNav();
                setSideNavCreated(true);
            }
            scrollToId();
        }
    }, 200); // check every 200ms

    function createSideNav() {
        const sideNavUl = document.querySelector("#side-nav-ul");
        const opTagsNodeList = document.querySelectorAll("[data-tag]");
        const opTags = Array.prototype.slice.call(opTagsNodeList);

        // For each API group (i.e. Clients, CustomFields, etc.) create an anchor tag and nest it in a list item
        opTags.forEach(tag => {
            const tagLi = document.createElement("li");
            const tagA = document.createElement("a");
            let opBlockUl = document.createElement("ul");
            const opName = tag.getAttribute("data-tag");
            const opId = tag.getAttribute("id");

            const parent = tag.parentElement;
            const opBlocksNodeList = parent.querySelectorAll(".opblock");
            const opBlocks = Array.prototype.slice.call(opBlocksNodeList);

            tagA.innerText = opName;
            tagA.href = `#${opId}`;
            tagA.classList.add("op-tag-link");
            tagA.addEventListener("click", scrollToId);
            tagLi.appendChild(tagA);
            tagLi.appendChild(opBlockUl);

            // For each API method within each API group create an anchor tag and nest it in a list item inside of an unordered list
            // opBlocks.forEach(opBlock => {
            //     const opBlockName = opBlock.querySelector(".opblock-summary-description").innerText;
            //     const opBlockId = opBlock.getAttribute("id");
            //     const opBlockLi = document.createElement("li");
            //     const opBlockA = document.createElement("a");

            //     opBlockA.innerText = opBlockName;
            //     opBlockA.href = `#${opBlockId}`;
            //     opBlockA.classList.add("op-block-link");
            //     opBlockA.addEventListener("click", scrollToId);
            //     opBlockLi.appendChild(opBlockA);
            //     opBlockUl.appendChild(opBlockLi);
            // })

            sideNavUl?.appendChild(tagLi);
        })

        const schema = document.querySelector(".models-control");
        const schemaLi = document.createElement("li");
        const schemaA = document.createElement("a");

        schema?.setAttribute("id", "schema");
        schemaA.innerText = "Schemas";
        schemaA.href = "#schema";
        schemaA.classList.add("op-tag-link");
        schemaA.addEventListener("click", scrollToId);
        schemaLi.appendChild(schemaA);

        sideNavUl?.appendChild(schemaLi);
    }

    function scrollToId() {
        setTimeout(() => {
            if (window.location.hash) {
                const hash = window.location.hash;
                const element = document.querySelector(hash);
                const btn = element?.querySelector(".opblock-summary-control") as HTMLButtonElement;
                element?.scrollIntoView({ block: 'start', behavior: 'smooth' });
                btn?.click();
            }
        }, 50);
    }

    function copyBaseUrl() {
        const baseUrlInput: HTMLInputElement | null = document.querySelector("#base-url");
        const baseUrlCopyBtn: HTMLButtonElement | null = document.querySelector('#base-url-copy-btn');
        if (baseUrlInput?.value != null && baseUrlCopyBtn?.innerText != null) {
            navigator.clipboard.writeText(baseUrlInput.value);
            baseUrlCopyBtn.innerText = "Copied!";
            setTimeout(() => {
                baseUrlCopyBtn.innerHTML = 'Copy <span class="fa-regular fa-copy"></span>';
            }, 2000);
        }
    }

    // function getFooterYear() {
    //     const footerSpan: HTMLSpanElement | null = document.querySelector("#year");
    //     if (footerSpan) {
    //         let year = new Date().getFullYear();
    //         footerSpan.innerText = String(year);
    //     }
    // } getFooterYear();





    return (<>
        <main className="docs-wrapper">
            <nav id="side-nav" aria-label="Secondary">
                <ul id="side-nav-ul"></ul>
            </nav>
            <div id="main-content">
                <h1 className="api-docs-h1 mt-3 mb-2">API Documentation</h1>
                <p className="text-gray mb-5">Integrate with Bilflo API's and get access to clients, company settings, contractors, custom fields, direct hires, overtime rules, and users. Any questions? Feel free to reach out at <a href="mailto:support@bilflo.com">support@bilflo.com</a></p>
                <div className="d-flex flex-column mb-5">
                    <div className="d-flex flex-column gap-1 mb-5">
                        <label htmlFor="base-url">Base URL</label>
                        <div className="d-flex flex-row align-items-center gap-2">
                            <input id="base-url" className="base-url-input" type="text" value="https://api.bilflo.com/v1/" readOnly />
                            <button id="base-url-copy-btn" className="copy-btn" onClick={copyBaseUrl}>Copy<span className="fa-regular fa-copy"></span></button>
                        </div>
                    </div>
                    <Table>
                        <thead>
                            <tr>
                                <th>Headers</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>company-id</td>
                                <td>Guid provided by Staffing Company</td>
                            </tr>
                            <tr>
                                <td>api-key</td>
                                <td>see <a href="/credentials">Credentials</a></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div id="api-docs"></div>
            </div>
        </main>
    </>
    );
};